export class  EditSavedSearchMessages  {
    public static OnUpdatingSavedSearchSuccess: string = "Your search was updated successfully";
    public static OnCreateSavedSearchSuccess: string = "Your search was created successfully";
}